import {
  Table,
  TablePagination,
  TechnicalMessageListRow,
  messagesColumns,
  useTechnicalMessageContext,
} from '@components';

export const TechnicalMessageList = () => {
  const { messages, isWorking, isError, id, offset, totalCount, itemsPerPage } =
    useTechnicalMessageContext();

  return (
    <>
      <Table
        headerColumns={messagesColumns()}
        isWorking={isWorking}
        list={messages}
        isError={isError}
        renderRow={(message) => (
          <TechnicalMessageListRow key={message.id} message={message} isWorking={isWorking} />
        )}
      />
      <TablePagination
        id={id}
        start={offset}
        totalCount={totalCount}
        itemsPerPage={itemsPerPage}
        isWorking={isWorking}
      />
    </>
  );
};
